export const OPEN_AUDIENCE_NAME = 'OpenAudience';
